import type { BaseTranslation } from '../i18n-types';

export const verifyYourself = {
    toGetStarted: 'To get started you need:',
    needDevice: 'Device with camera',
    needSelfie: 'Willingness to take a selfie',
    needId: 'Identification document',
    secureInfo: 'The process is highly secure and it takes less than {minutes:number} minutes',
    agreement: 'I hereby consent to the processing of my biometric data, for the purpose of verifying my identity and in accordance with the <a class="link" href="{privacyLink:string}" target="_blank">Privacy Policy</a>.',
    button: 'Proceed to ID verification',
    success: 'The process will take up to {days:number} days. You will receive an email notification as soon as everything is ready.',
    failed: 'There is a problem with your verification. Restart the verification process one more time. If the problem persists, please contact us.',
} satisfies BaseTranslation;
